import { ColumnType } from "antd/es/table";
import { FilterValue } from "antd/es/table/interface";
import { QueryMode } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { FilterIcon } from "assets/icons";

import { TextFilterInput } from "./types";

import TableTextFilter from ".";

export const getColumnTextFilterProps = <T, D extends keyof T & string>(
  dataIndex: D,
  filteredValue?: FilterValue | null | undefined
): ColumnType<T> => ({
  filteredValue: filteredValue || null,
  filterDropdown: (props) => <TableTextFilter {...props} {...{ dataIndex }} />,
  filterIcon: ($filtered: boolean) => <FilterIcon {...{ $filtered }} />,
});

export const getTextFilterInput = <T extends string>(
  value: FilterValue | undefined | null,
  path: T
): TextFilterInput<T> => {
  if (!value?.length) {
    return {};
  }

  const [contains] = value;

  if (typeof contains !== "string" || !contains) {
    return {};
  }

  return {
    [path]: {
      contains,
      mode: QueryMode.insensitive,
    },
  } as TextFilterInput<T>;
};
